import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { LevelOfServiceService } from '../service/level-of-service.service';
import { sweetAlert } from 'src/app/utils/swal';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';

@Component({
  selector: 'app-space-types-list',
  templateUrl: './space-types-list.component.html',
  styleUrls: ['./space-types-list.component.css']
})
export class SpaceTypesListComponent implements OnInit {
  search;
  spaceTypes = [];
  user;
  status = "active"
  preLevelOfServices = {};

  constructor(
    private levelOfServiceService: LevelOfServiceService,
    private sharedDataService: SharedDataService,
  ) { }

  ngOnInit() {
    this.getLevelOfService();
    this.getSpaceTypes();
  }

  onChangeStatus(evt) {
    this.getSpaceTypes();
  }

  getSpaceTypes() {
    const queryParams = {
      status: this.status
    }

    this.levelOfServiceService
      .getSpaceTypes(queryParams)
      .subscribe(data => {
        if (data && data.length) {
          this.spaceTypes = data;
        } else {
          this.spaceTypes = [];
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getLevelOfService() {
    this.levelOfServiceService
      .getLevelOfServices({status: 'active'})
      .subscribe(data => {
        if (data) {
          this.preLevelOfServices = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }



  ngOnDestroy(): void {
  }

}
